module.exports = __webpack_public_path__ + "img/remediations.198e67e8.jpg";